/* ============================================================
   SAYSIRI v4/v5/v6 — storefront patches (Claude)
   ------------------------------------------------------------
   PATCH 1: Product gallery navigation fix
   PATCH 2: Cart drawer "You may also like" (metafield-driven)
   PATCH 3: Search suggestions — price fix + wider field matching
   Loaded once in theme.liquid, after all sections.
   ============================================================ */

/* ------------------------------------------------------------
   PATCH 1 — gallery navigation
   Problem: the product section's spdpGoTo() calls
   thumbs[i].scrollIntoView({inline:'nearest', behavior:'smooth'})
   after each image change. scrollIntoView defaults block:'start',
   which vertically scrolls the WHOLE PAGE to pin the thumbnail
   strip at the top — so tapping next/prev on mobile jumps the
   page down to the thumbnails/description.
   Fix: redefine spdpGoTo/spdpNav (this file loads after the
   section script, so these definitions win). Identical behaviour,
   except the thumbnail strip is scrolled horizontally within its
   own container only — the page never moves.
   ------------------------------------------------------------ */
(function () {
  function defineFixedGalleryNav() {
    window.spdpGoTo = function (index, sid) {
      var wrap = document.getElementById('spdpWrap-' + sid);
      if (!wrap) return;
      var slides = wrap.querySelectorAll('.spdp-main-img-slide');
      var thumbs = wrap.querySelectorAll('.spdp-thumb');
      var counter = wrap.querySelector('#spdpCurrent');
      var total = slides.length;
      if (!total) return;
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      slides.forEach(function (s) { s.classList.remove('is-active'); });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });

      if (slides[index]) slides[index].classList.add('is-active');
      if (thumbs[index]) {
        thumbs[index].classList.add('is-active');
        /* Horizontal scroll inside the strip only — no page jump */
        var strip = wrap.querySelector('.spdp-thumbs');
        if (strip) {
          var t = thumbs[index];
          var target = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
          if (target < 0) target = 0;
          if (typeof strip.scrollTo === 'function') {
            strip.scrollTo({ left: target, behavior: 'smooth' });
          } else {
            strip.scrollLeft = target;
          }
        }
      }
      if (counter) counter.textContent = index + 1;
    };

    window.spdpNav = function (dir, sid) {
      var wrap = document.getElementById('spdpWrap-' + sid);
      if (!wrap) return;
      var slides = wrap.querySelectorAll('.spdp-main-img-slide');
      var current = 0;
      slides.forEach(function (s, i) {
        if (s.classList.contains('is-active')) current = i;
      });
      window.spdpGoTo(current + dir, sid);
    };
  }

  defineFixedGalleryNav();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', defineFixedGalleryNav);
  }
})();

/* ------------------------------------------------------------
   PATCH 2 — cart drawer "You may also like"
   Injects a container after the cart items list and fills it
   with the server-rendered sections/cart-upsell.liquid (Section
   Rendering API), which reads each cart item's
   custom.complete_look metafield — the same field driving the
   product-page "Complete the Look" box, so both always coincide.
   A MutationObserver on the items list refreshes the suggestions
   whenever the drawer re-renders (open, qty change, add, remove).
   ------------------------------------------------------------ */
(function () {
  function initCartUpsell() {
    var items = document.getElementById('scdItems');
    var drawer = document.getElementById('scdDrawer');
    if (!items || !drawer) return;

    var holder = document.getElementById('scdDynamicUpsell');
    if (!holder) {
      holder = document.createElement('div');
      holder.id = 'scdDynamicUpsell';
      holder.style.flexShrink = '0';
      items.insertAdjacentElement('afterend', holder);
    }

    var timer;
    function load() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch('/?sections=cart-upsell')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            holder.innerHTML = (d && d['cart-upsell']) ? d['cart-upsell'] : '';
          })
          .catch(function () { /* keep previous content */ });
      }, 150);
    }

    new MutationObserver(load).observe(items, { childList: true });
    load();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartUpsell);
  } else {
    initCartUpsell();
  }
})();

/* ------------------------------------------------------------
   PATCH 3 — search suggestions: price fix + wider matching
   Problems in sections/search-results.liquid live dropdown:
   (a) Price rendered with (parseInt(p.price, 10) / 100).toFixed(0)
       but /search/suggest.json returns DIRHAMS ("325.00"), not
       fils — so AED 325 displayed as "AED 3".
   (b) The suggest.json call passes no resources[options][fields],
       so Shopify only matches titles/SKUs — queries like
       "scarves" or "prayer wear" (which live in tags, body or
       plural forms) returned nothing even though the full search
       page finds them.

   Fix: wrap window.fetch for suggest.json calls to
   1) append a fields param (title, tag, body, product_type,
      vendor, variant titles) so the dropdown matches like the
      full search page, and
   2) build a url → correctly-formatted-price map; corrections
      are applied when data lands AND on every dropdown render.

   PERMANENT FIX for Bahar in sections/search-results.liquid:
   • replace the price expression with
     Math.round(parseFloat(p.price)).toLocaleString()
   • append '&resources[options][fields]=title,product_type,tag,body,vendor,variants.title'
     to the suggest.json fetch URL
   then delete this patch.
   ------------------------------------------------------------ */
(function () {
  var suggestEl = document.getElementById('ssrSuggest');
  if (!suggestEl) return; /* only runs on the search page */

  var FIELDS_PARAM = '&resources[options][fields]=title,product_type,tag,body,vendor,variants.title';
  var priceByUrl = {};

  function applyCorrections() {
    suggestEl.querySelectorAll('.ssr-suggest-item').forEach(function (a) {
      var priceEl = a.querySelector('.ssr-suggest-price');
      var href = a.getAttribute('href');
      var correct = null;
      for (var key in priceByUrl) {
        if (href === key || href.split('?')[0] === key.split('?')[0]) { correct = priceByUrl[key]; break; }
      }
      if (priceEl && correct && priceEl.textContent !== correct) {
        priceEl.textContent = correct;
      }
    });
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    if (url.indexOf('/search/suggest.json') === -1) {
      return origFetch.apply(this, arguments);
    }
    /* widen the matched fields so tags/descriptions/plurals hit */
    if (url.indexOf('resources[options][fields]') === -1) {
      url += FIELDS_PARAM;
    }
    var args = Array.prototype.slice.call(arguments);
    args[0] = url;
    return origFetch.apply(this, args).then(function (res) {
      res.clone().json().then(function (data) {
        var products = data && data.resources && data.resources.results && data.resources.results.products;
        (products || []).forEach(function (p) {
          if (p.url && p.price) {
            priceByUrl[p.url] = 'AED ' + Math.round(parseFloat(p.price)).toLocaleString();
          }
        });
        applyCorrections();
        setTimeout(applyCorrections, 60);
        setTimeout(applyCorrections, 300);
      }).catch(function () {});
      return res;
    });
  };

  new MutationObserver(applyCorrections).observe(suggestEl, { childList: true });
})();
